/**
 * Enum for unit type locales
 */
export enum UnitLocaleEnum {
  METRIC = 'metric',
  IMPERIAL = 'imperial'
}
